import React, { useMemo } from 'react';
import { apiHolder } from 'api';
import classnames from 'classnames/bind';
import { useObservable } from 'rxjs-hooks';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import pinyin from 'tiny-pinyin';
import style from './chatForward.module.scss';
import { UserAvatar, TeamAvatar } from '../../common/imUserAvatar';
import { useYunxinAccount } from '../../common/hooks/useYunxinAccount';
import { useImTeam } from '../../common/hooks/useTeamInfo';
const realStyle = classnames.bind(style);
const nimApi = apiHolder.api.requireLogicalApi('NIM');
export const UserItem = props => {
    const { id } = props;
    const user = useYunxinAccount(id);
    return (React.createElement(React.Fragment, null,
        React.createElement(UserAvatar, { user: user }),
        React.createElement("p", { className: realStyle('sessionName') }, (user === null || user === void 0 ? void 0 : user.nick) || '')));
};
export const TeamItem = props => {
    const { id } = props;
    const team = useImTeam(id);
    return (React.createElement(React.Fragment, null,
        React.createElement(TeamAvatar, { teamId: (team === null || team === void 0 ? void 0 : team.teamId) || '', teamInfo: team }),
        React.createElement("p", { className: realStyle('sessionName') }, (team === null || team === void 0 ? void 0 : team.customTeamName) || '')));
};
export const ChatForwardP2PItem = props => {
    const { to, keyword, children, onchange } = props;
    const username = useObservable((_, $props) => {
        const $to = $props.pipe(map(([id]) => id));
        const name = nimApi.imusers.getUserProp($to, of('nick'));
        return name.pipe(map(val => [val, pinyin.convertToPinyin(val).toLowerCase()]));
    }, ['', ''], [to]);
    const visible = useMemo(() => username.some(item => item.indexOf(keyword.toLocaleLowerCase()) !== -1), [keyword]);
    return (React.createElement("li", { onClick: () => {
            onchange('p2p-' + to);
        }, className: realStyle('sessionItem', visible ? 'visible' : 'hidden') },
        children,
        React.createElement(UserItem, { id: to })));
};
export const ChatForwardTeamItem = props => {
    const { to, keyword, children, onchange } = props;
    const teamname = useObservable((_, $props) => {
        const $to = $props.pipe(map(([id]) => [id, 'customTeamName']));
        const $name = nimApi.imteamStream.getTeamField($to);
        return $name.pipe(map(val => [val, pinyin.convertToPinyin(val).toLowerCase()]));
    }, ['', ''], [to]);
    const visible = useMemo(() => teamname.some(item => (item === null || item === void 0 ? void 0 : item.toLowerCase().indexOf(keyword.toLocaleLowerCase())) !== -1), [keyword]);
    return (React.createElement("li", { onClick: () => {
            onchange('team-' + to);
        }, className: realStyle('sessionItem', visible ? 'visible' : 'hidden') },
        children,
        React.createElement(TeamItem, { id: to })));
};
